import { AvForm } from 'availity-reactstrap-validation'
import RenderFields from '../../../CMSComponent/Forms/renderFields'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { primary_color } from '../../../Helper/uiHelper'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import NewCodeButton from '../PlannedBlock/codes/newCodeButton'
import ChangeSequenceButton from '../PlannedBlock/codes/changeSequenceButton'

const tabHasPermission = (permissions, name) => Array.isArray(permissions) && permissions.includes(name)

const EditBookingDetails = ({ setAddGridDataDetail, addDataDetail, addFormList, fetechLogsCount }) => {
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const purchasePage = useSelector((state) => state.CMS.coreData?.page?.purchase)

  const [formFieldValue, setFormFieldValue] = useState({})
  const [defaultSingleFormValue, setDefaultSingleFormValue] = useState()
  const [loading, setLoading] = useState(false)
  const [alreadyBookedWarning, setAlreadyBookedWarning] = useState(null)
  const [isAutomatic, setIsAutomatic] = useState(false)
  const [canChangeSequence, setCanChangeSequence] = useState(false)
  const [mutationBlockedMessage, setMutationBlockedMessage] = useState(null)
  const [automaticItem, setAutomaticItem] = useState(null)
  const dispatch = useDispatch()

  const unitRow =
    currentRow?.find((row) => row?.item_id != null) ?? (currentRow?.length > 1 ? currentRow[1] : currentRow?.[0])

  const bookingsTabPermissions = purchasePage?.component_call_buttons?.find((tab) => tab.name === 'bookings_units')?.permission
  const canRequestNewCode =
    tabHasPermission(addDataDetail?.currentTabData?.permission, 'new_code') ||
    tabHasPermission(bookingsTabPermissions, 'new_code')

  const loadAutomaticStatus = (unit) => {
    if (!unit?.item_id) {
      setIsAutomatic(!!unit?.is_automatic)
      setAutomaticItem(null)
      return
    }
    request('automatic-codes/item-status', 'POST', { item_id: unit.item_id }).then((res) => {
      if (res?.status !== 200) return
      const automatic = !!res?.data?.is_automatic || !!unit?.is_automatic
      setIsAutomatic(automatic)
      setCanChangeSequence(!!res?.data?.can_change_sequence)
      setMutationBlockedMessage(res?.data?.mutation_blocked_message || null)
      if (automatic) {
        setAutomaticItem({
          id: unit.item_id,
          is_automatic: true,
          block_group_dynamic_id: res?.data?.block_group_dynamic_id,
          code_sequence: res?.data?.code_sequence,
          can_change_sequence: res?.data?.can_change_sequence,
          mutation_blocked_message: res?.data?.mutation_blocked_message,
          is_sold: unit?.locker_status === 'Booked',
        })
      } else {
        setAutomaticItem(null)
      }
    })
  }

  useEffect(() => {
    if (unitRow) {
      setDefaultSingleFormValue(unitRow)
      loadAutomaticStatus(unitRow)
    }
  }, [unitRow?.id])

  const onCloseForm = () => {
    dispatch(fetchUpdateApiData())
    if (!addDataDetail?.isAddNew) {
      dispatch(clearCurrentRowData())
      dispatch(clearParentTableData())
    }
    setAddGridDataDetail({ open: false })
  }

  const onSave = (values) => {
    setLoading(true)
    request('update-unit-details', 'POST', {
      ...values,
      unit_id: unitRow?.id,
    }).then((res) => {
      if (res?.status === 409 && res?.data?.already_booked) {
        setAlreadyBookedWarning(
          res?.data?.message || `This locker is already booked under booking ID ${res?.data?.booking_id || 'unknown'}.`
        )
        setLoading(false)
        return
      }
      if (isSuccessResponse(res, 'Details updated successfully!')) {
        setAlreadyBookedWarning(null)
        onCloseForm()
      }
      fetechLogsCount()
      setLoading(false)
    })
  }

  if (addFormList?.length !== 1) return
  return (
    <div className='p-4 px-5'>
      {isAutomatic && canRequestNewCode && unitRow?.item_id ? (
        <div className='mb-3 d-flex align-items-center flex-wrap' style={{ gap: '0.75rem' }}>
          <span className='subtitle1 font-weight-bold' style={{ color: primary_color }}>
            Automatic Code
          </span>
          <NewCodeButton
            itemId={unitRow.item_id}
            disabled={!canChangeSequence}
            blockedMessage={mutationBlockedMessage}
          />
          {automaticItem ? (
            <ChangeSequenceButton
              item={automaticItem}
              onDone={() => {
                loadAutomaticStatus(unitRow)
                fetechLogsCount()
                dispatch(fetchUpdateApiData())
              }}
            />
          ) : null}
        </div>
      ) : null}
      <AvForm
        onValidSubmit={(e, values) => {
          onSave(values)
        }}>
        <RenderFields
          allForm={addFormList}
          content={addFormList}
          twoCol={true}
          defaultFormValue={defaultSingleFormValue}
          formFieldValue={formFieldValue}
          setFormFieldValue={setFormFieldValue}
          noCache={true}
        />
        <div className='d-flex justify-content-end mt-5'>
          {' '}
          <button
            className='btn rounded-pill mt-2 text-danger border-danger mr-3'
            type='button'
            id='close-btn'
            onClick={(e) => {
              onCloseForm()
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{ fontWeight: 700, width: '12rem' }}>
            Close
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            type='submit'
            id='save-button'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </AvForm>
      <Modal isOpen={!!alreadyBookedWarning} centered toggle={() => setAlreadyBookedWarning(null)}>
        <ModalHeader toggle={() => setAlreadyBookedWarning(null)}>Locker already booked</ModalHeader>
        <ModalBody>{alreadyBookedWarning}</ModalBody>
        <ModalFooter>
          <Button color='primary' style={{ background: primary_color, border: 'none' }} onClick={() => setAlreadyBookedWarning(null)}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default EditBookingDetails
